export enum PrizeTypesNames {
  imac_pro = 'IMac Pro',
  iphone_17 = 'IPhone 17',
  usd_5 = '5 USD',
  samsung_galaxy_book2_pro = 'Samsung Galaxy Book2 Pro',
  macbook_pro = 'MacBook Pro',
  samsung_s25_ultra = 'Samsung S25 Ultra',
  samsung_galaxy_watch = 'Samsung Galaxy Watch',
  apple_watch = 'Apple Watch',
  golden_bar_1g = 'Golden Bar 1g',
  air_pods = 'AirPods',
  smartphone = 'Smartphone',
  usd_10000 = 'SuperPrize: 10 000 USD',
  christmas_tree = 'Christmas Tree',
}
